// src/components/flux/FluxConnection.jsx
import React from 'react';
//import './FluxConnection.css';

const FluxConnection = ({ id, source, target, label }) => {
  // Calcular puntos para la conexión
  const calculateConnectionPoints = () => {
    // Cálculo de puntos de origen (punto de salida del nodo fuente)
    const sourceX = source.position.x + 150; // Asumiendo que el nodo tiene 150px de ancho
    const sourceY = source.position.y + 50;  // Asumiendo que el punto de salida está a 50px desde arriba
    
    // Cálculo de puntos de destino (punto de entrada del nodo objetivo)
    const targetX = target.position.x;
    const targetY = target.position.y + 50;  // Asumiendo que el punto de entrada está a 50px desde arriba
    
    // Para la curva Bezier, calculamos dos puntos de control
    const controlPointX1 = sourceX + (targetX - sourceX) * 0.3;
    const controlPointY1 = sourceY;
    const controlPointX2 = targetX - (targetX - sourceX) * 0.3;
    const controlPointY2 = targetY;
    
    // Calculamos el punto medio para colocar la etiqueta
    const midX = (sourceX + targetX) / 2;
    const midY = (sourceY + targetY) / 2;
    
    return {
      sourceX,
      sourceY,
      targetX,
      targetY,
      controlPointX1,
      controlPointY1,
      controlPointX2,
      controlPointY2,
      midX,
      midY
    };
  };
  
  const points = calculateConnectionPoints();
  
  // Construimos el path para la curva Bezier
  const pathData = `
    M ${points.sourceX} ${points.sourceY}
    C ${points.controlPointX1} ${points.controlPointY1},
      ${points.controlPointX2} ${points.controlPointY2},
      ${points.targetX} ${points.targetY}
  `;
  
  return (
    <>
      <svg className="flux-connection">
        <path
          d={pathData}
          className="connection-path"
          markerEnd="url(#arrowhead)"
        />
        
        {/* Definiciones para el marcador de flecha */}
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="9"
            refY="3.5"
            orient="auto"
          >
            <polygon points="0 0, 10 3.5, 0 7" />
          </marker>
        </defs>
      </svg>
      
      {/* Etiqueta de la conexión */}
      {label && (
        <div 
          className="connection-label"
          style={{
            left: `${points.midX}px`,
            top: `${points.midY}px`
          }}
        >
          {label}
        </div>
      )}
    </>
  );
};

export default FluxConnection;